import { useQuery } from "@tanstack/react-query";
import { TrainIdentifier } from "@vygruppen/vy-train-map";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import { DescribedType } from "features/CenterContent/shared/operationalInformation/utils";
import { Stop } from "features/CenterContent/VehicleDetails/TrainDetails/useExistingTrainCancelledEvents";
import { AffectedStop, Distribution } from "shared/types/historyDetail";

export type Group =
  | "TRAIN"
  | "INFRASTRUCTURE"
  | "STATION"
  | "GLOBAL"
  | "ALTERNATIVE_TRANSPORT";

type EventType = {
  type: string;
  group: Group;
  label: string | null;
};

export type OriginSystem = {
  reference: string;
  name: string;
  user: string | null;
};

type ActionCard = {
  type: string;
};

export type Visibility = {
  type: "TIMED" | "OPEN_ENDED" | "CONSTANT";
  fromTime: Date | null;
  toTime: Date | null;
};

export type State =
  | "OPEN"
  | "CLOSED"
  | "REPLACED"
  | "UNHANDLED"
  | "DEPUBLISHED";

export type Information = {
  // action?
  actionCard: ActionCard | null;
  createdAt: Date;
  distributions: Distribution[];
  isVisible: boolean;
  visibility: Visibility;
  originSystem: OriginSystem;
  reason: DescribedType;
  state: State;
  stretchName: string;
  affectedStops: AffectedStop[] | null;
  stops: AffectedStop[] | null;
  type: EventType;
  updatedAt: Date;
  uuid: string;
  version: number;
  countryCode: string;

  // internalMessage fields
  relevantStops?: Stop[];
  relevantTrain?: TrainIdentifier;
  relatedEventUuid?: string;
};

export type HistoryInformationDetailResponse = {
  uuid: string;
  versions: Information[];
  replaced: string | null;
};

export const HISTORY_DETAILS_QUERY_KEY = "historyDetails";

export const useHistoryDetail = (uuid: string | undefined) =>
  useQuery({
    queryKey: [HISTORY_DETAILS_QUERY_KEY, uuid],
    refetchInterval: 60000,
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      queryFnGET<HistoryInformationDetailResponse>({
        signal,
        url: `${getBackendUrl()}/operational-information/${uuid}`,
      }),
    gcTime: 0,
    enabled: !!uuid,
  });
